module.exports = __webpack_public_path__ + "media/images/logos/rotpunkt-logo-9122265c20744d5bcc850a23f4663dc4.svg";